import { useAuth } from 'drycut-auth';
import { CompleteStoreFragment, useGetStoreQuery } from 'drycut-graphql';
import { PropsWithChildren, createContext, useContext } from 'react';

type StoreContextValue = {
  store: CompleteStoreFragment | null | undefined;
  loading: boolean;
};

const StoreContext = createContext<StoreContextValue>({
  store: null,
  loading: false,
});

export function StoreProvider({ children }: PropsWithChildren): React.ReactElement {
  const { currentSlug } = useAuth();

  const { data, loading } = useGetStoreQuery({
    variables: { slug: currentSlug || '' },
  });

  const store = data?.store;

  return <StoreContext.Provider value={{ store, loading }}>{children}</StoreContext.Provider>;
}

export const useStoreContext = () => {
  const { store, loading } = useContext(StoreContext);

  return { store, loading };
};
